import { createFileRoute } from '@tanstack/react-router'
import { MusicListPage } from '@/pages/MusicList/MusicListPage'

export const Route = createFileRoute('/music/')({
  component: MusicPage,
  head: () => ({
    meta: [
      {
        title: 'Music - Copshop',
      },
      {
        name: 'description',
        content: 'View your music collection.',
      },
    ],
  }),
})

function MusicPage() {
  return <MusicListPage />
}
